import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Switch } from '#src/atoms/inputs/Switch/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';

const messages = defineMessages({
  saveCreditCard: {
    id: 'PaymentMethodPicker.saveCreditCard',
    defaultMessage: 'Save your credit card for later purchases',
  },
});

export const SaveCreditCard = ({
  saveCreditCard,
  toggleSaveCreditCard,
  label = messages.saveCreditCard,
}: {
  saveCreditCard: boolean;
  toggleSaveCreditCard: () => void;
  label?: MessageDescriptor;
}) => {
  return (
    <Horizontal>
      <Switch checked={saveCreditCard} onChange={toggleSaveCreditCard} />
      <LabelM color="var(--c-white)">
        <FormattedMessage {...label} />
      </LabelM>
    </Horizontal>
  );
};
